import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import BrandBar from "@/components/BrandBar";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="film-grain monitor-glow">
      <BrandBar />
      <div style={{ paddingTop: '32px' }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
          </Routes>
        </BrowserRouter>
      </div>
      <Toaster
        position="bottom-right"
        theme="dark"
        richColors
        toastOptions={{
          style: {
            background: '#1a1d21',
            border: '1px solid #2a2e36',
            color: '#d4d4d8',
            fontFamily: "'DM Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
